<template>
  <div class="Home">
    <div>
      <h2>落箱用户登录</h2>
      <van-form @submit="onSubmit">
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">
            消息订阅
          </van-button>
        </div>
      </van-form>
      <tabbar :selected="selected"></tabbar>
    </div>
    <wx-open-subscribe template="8EIMo1kCjzvrzKimM424j6OrPacEDNTvRCCNheNuKtE" id="subscribe-btn">
      <script type="text/wxtag-template" slot="style">
        <style>
          .subscribe-btn {
            color: #fff;
            background-color: #07c160;
          }
        </style>
      </script>
      <script type="text/wxtag-template">
        <button class="subscribe-btn">
          消息订阅
        </button>
      </script>
    </wx-open-subscribe>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import common from "../common";

export default {
  data() {
    return {
      title: "test"
    }
  },
  methods: {
    //获取数据
    getJsConfig() {
      let querystring = require("querystring");
      this.$api.post("/wx/jsConfig",
          querystring.stringify({
            url: location.href.split("#")[0]
          })
      ).then(data => {
        wx.config({
          debug: false,
          appId: data.data.data.appId,
          timestamp: data.data.data.timestamp,
          nonceStr: data.data.data.nonceStr,
          signature: data.data.data.signature,
          jsApiList: [],
          openTagList: ["wx-open-subscribe"]
        });
      }).catch(err => {
        common.toast(err);
      });
    }
  },
  mounted() {
    this.getJsConfig();
  }
}
</script>

<style scoped>
.subscribe-btn {
  color: #fff;
  background-color: #07c160;
}
</style>


// WEBPACK FOOTER //
// src/components/subscribe.vue